export const QUERY_COMPANY_OPTION = (title?: string) => [
  'QUERY_COMPANY_OPTION',
  title ?? '',
];
